/* eslint-disable react/destructuring-assignment */
import React from 'react';
import styles from './LoaderOverlayFullScreen.module.scss';
import seguroLaboral from '../../assets/seguroLaboral.svg';
import ACHSLoaderAnimation from '../../assets/ACHSLoader.gif';

interface LoaderOverlayFullScreenProps {
	style: any;
}

/**
 * LoaderOverlayFullScreen component (wrapper for pages).
 *
 * @param {any} props - Component props.
 * @param {any} props.style - styles of various component.
 * @returns {JSX.Element} LoaderOverlayFullScreen component.
 */

const LoaderOverlayFullScreen: React.FC<LoaderOverlayFullScreenProps> = (
	props,
): JSX.Element => (
	<div
		className={styles.overlayFullScreen}
		style={props.style}
		tabIndex={-1}
		role='dialog'
		aria-labelledby='loadingPagesTitle'
		data-backdrop='static'
	>
		<div className={styles.overlayContent}>
			<img
				draggable={false}
				src={ACHSLoaderAnimation}
				alt='Cargando'
				className={styles.marginBottom}
			/>
			<img draggable={false} src={seguroLaboral} alt='Seguro Laboral' />
		</div>
	</div>
);

export default LoaderOverlayFullScreen;
